import React, {createContext, useCallback, useContext, useEffect, useMemo, useState} from "react";

interface EntsorgungsdokumentationSelectionContextType {
    gewaehlteAbladestellenMaterialien: string[];
    setGewaehlteAbladestellenMaterialien: (ids: string[]) => void;
    isGewaehlt: boolean;
}

const EntsorgungsdokumentationSelectionContext = createContext<
    EntsorgungsdokumentationSelectionContextType | undefined
>(undefined);

export function EntsorgungsdokumentationSelectionProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    const [gewaehlteAbladestellenMaterialien, setGewaehlteAbladestellenMaterialienState] = useState<string[]>([]);

    const isGewaehlt = useMemo(
        () => gewaehlteAbladestellenMaterialien.length > 0,
        [gewaehlteAbladestellenMaterialien]
    );

    const setGewaehlteAbladestellenMaterialien = useCallback((ids: string[]) => {
        setGewaehlteAbladestellenMaterialienState(ids);
    }, []);

    const value = useMemo(
        () => ({
            gewaehlteAbladestellenMaterialien,
            setGewaehlteAbladestellenMaterialien,
            isGewaehlt,
        }),
        [gewaehlteAbladestellenMaterialien, setGewaehlteAbladestellenMaterialien, isGewaehlt]
    );

    return (
        <EntsorgungsdokumentationSelectionContext.Provider value={value}>
            {children}
        </EntsorgungsdokumentationSelectionContext.Provider>
    );
}

export function useEntsorgungsdokumentationSelection() {
    const context = useContext(EntsorgungsdokumentationSelectionContext);
    if (context === undefined) {
        throw new Error(
            "useEntsorgungsdokumentationSelection must be used within EntsorgungsdokumentationSelectionProvider"
        );
    }
    return context;
}
